//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { useFeature } from "flagged";

export const useArangoPlatformFeature = () => {
  const arangoPlatform = !!useFeature("ArangoPlatform");
  const arangoDBPlatform = !!useFeature("ArangoDBPlatform");
  const isArangoPlatformFeatureEnabled = arangoPlatform || arangoDBPlatform;

  return { isArangoPlatformFeatureEnabled };
};
